var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language",on:{"click":_vm.handleSetLanguage}},[_c('img',{staticClass:"language_img",attrs:{"src":require("./en.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }